<html lang="en">
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Payment Complete</title>

  <body>
    <div class="success-container">
      <div class="success-icon">&#10004;</div>
      <div class="success-message">
        Congratulations! You've successfully upgraded up to the
        {{ planName }} Plan.
      </div>
      <!-- <div class="instructions">
        To unlock your bonus content log back into the app.
      </div> -->
      <button mat-button color="primary" routerLink="/home">Go to Home</button>
    </div>
  </body>
</html>
